export const DefectTrackerActions = {
  VIEW: "VIEW",
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  RENAME: "RENAME",
  CONNECT: "CONNECT",
};
